import { Perspective } from '@v2/pages/common/enums';
import { useSelector } from 'react-redux';
import { selectSingleBatchData } from '@reducers/batch';
import { selectJobsData, selectNcFileData, selectPartsData, selectProductionOrderData } from '@reducers/details';
import { selectClampingTools } from '@reducers/clampingTools';
import { PerspectiveParams, ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import {
  ClampingTool,
  NCFileSearchItem,
  OperationSearchItem,
  PartSearchItem,
  ProductionBatchStatistics,
  ProductionOrderSearchItem,
} from '../../../../../interfaces/search';

export const useGetNavigationParams = () => {
  const batchData: ReducerEntityWithLoadingState<ProductionBatchStatistics | null> = useSelector(selectSingleBatchData);
  const jobsData: ReducerEntityWithLoadingState<OperationSearchItem[]> = useSelector(selectJobsData);
  const partData: ReducerEntityWithLoadingState<PartSearchItem[]> = useSelector(selectPartsData);
  const ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem[] | NCFileSearchItem | null> = useSelector(selectNcFileData);
  const productionOrderData: ReducerEntityWithLoadingState<ProductionOrderSearchItem[]> = useSelector(selectProductionOrderData);
  const tools: ClampingTool[] = useSelector(selectClampingTools);

  const batch = batchData?.data;
  const job = jobsData?.data?.[0];
  const part = partData?.data?.[0];
  const ncFile = Array.isArray(ncFileData?.data) ? ncFileData?.data?.[0] : ncFileData.data;
  const productionOrder = productionOrderData?.data?.[0];
  const tool = tools?.[0];

  const getNavigationParams = (perspective: Perspective): PerspectiveParams => {
    return {
      perspective,
      ncFileId: ncFile?.ncFileId ?? '',
      ncFileName: ncFile?.ncFileName ?? '',
      ncFileStatus: ncFile?.ncFileStatus ?? '',
      batchNumber: batch?.batchNumber ?? '',
      batchId: batch?.productionBatchId ?? '',
      partId: part?.partId,
      partName: part?.partName,
      productionOperationId: job?.productionOperationId,
      jobName: job?.productionOperationNumber,
      productionOrderId: productionOrder?.productionOrderId ?? job?.productionOrderId,
      productionOrderName: productionOrder?.productionOrderNumber,
      toolId: tool?.toolId,
      toolName: tool?.toolName,
      keepList: true,
      selectedProductionOperationId: job?.productionOperationId,
    };
  };

  return {
    getNavigationParams,
  };
};
